import gql from 'graphql-tag'
import { get } from 'lodash'
import { ITopicVersion } from '../../../../../types/TopicVersion'
import { apolloClientPrivate } from '../../../graphql/apolloClient'

export interface IVariables {
  topicId: number
}

export interface IResponse {
  data: {
    workspace: {
      id: number
      TopicModelAsEditor: {
        id: number
        draftVersion: {
          id: number
          title: string
          summary: string
          updated_at: Date
          scormCourse: {
            status: string
            job_details: Record<string, unknown>
            file_details: Record<string, unknown>
            updated_at: Date
          }
        }
      }
    }
  }
}

export type IOperationResult = Pick<
  ITopicVersion,
  'id' | 'title' | 'summary' | 'updated_at' | 'scormCourse'
>

export default async (variables: IVariables): Promise<IOperationResult> => {
  const query = gql`
    query workspace($topicId: PositiveInt!) {
      topic(id: $topicId) {
        id
        lastPublishedDate
        ... on TopicModelAsEditor {
          draftVersion {
            id
            title
            summary
            updated_at
            scormCourse {
              id
              status
              job_details
              file_details
              updated_at
            }
          }
        }
      }
    }
  `

  const response = await apolloClientPrivate.query<IResponse>({
    variables,
    query
  })

  return get(response, 'data.topic.draftVersion')
}
